export const BASIC_BLOG = 'BASIC';
export const ADV_BLOG = 'ADV';
export const NONE = 'NONE';
